import React from 'react';
import { func, bool } from 'prop-types';

import { formPropType } from 'redux/userFormHandlers';

import { retrieveCustomForm } from './utils';

const CustomFormRenderer = ({ form, onSubmit, onCancel, isPublic }) => {
  const CustomForm = retrieveCustomForm(form.code);
  return <CustomForm form={form} onSubmit={onSubmit} onCancel={onCancel} isPublic={isPublic} />;
};

CustomFormRenderer.propTypes = {
  form: formPropType,
  onSubmit: func,
  onCancel: func,
  isPublic: bool
};

export default CustomFormRenderer;
